// HPC Report - PartDPage2 (Read-only displays for HPC Report)
import React from 'react';

const PartDPage2 = ({ data }) => {
  const teacherFields = data?.teacher_fields || {};

  const getTotalChecked = (category) => {
    if (!category) return 0;
    return [
      category.item_1_checked,
      category.item_2_checked,
      category.item_3_checked,
      category.item_4_checked,
      category.item_5_checked
    ].filter(Boolean).length;
  };

  const renderAssessmentCategory = (category, title) => {
    const categoryData = teacherFields[category] || {};
    const totalChecked = getTotalChecked(categoryData);

    return (
      <div style={{ marginBottom: '15px' }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          {/* Orange Label */}
          <div style={{
            backgroundColor: '#F4824C',
            color: 'white',
            padding: '10px',
            fontSize: '11px',
            fontWeight: 'bold',
            minWidth: '110px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {title}
          </div>

          {/* Main Content Area */}
          <div style={{
            flex: 1,
            backgroundColor: '#FFE5D5',
            padding: '12px'
          }}>
            {/* Instructions */}
            <div style={{ fontSize: '9px', marginBottom: '10px', lineHeight: '1.3' }}>
              Based on the type of interaction, choose <strong>five</strong> assessment parameters from
              page 36-37. Tick (✓) as per the learner's performance.
            </div>

            {/* Assessment Items Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 12px', marginBottom: '10px' }}>
              {/* Left Column - 3 items */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[1, 2, 3].map(num => (
                  <div key={num} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '14px' }}>{categoryData[`item_${num}_checked`] ? '☑' : '☐'}</span>
                    <div style={{
                      flex: 1,
                      borderBottom: '1px solid #999',
                      fontSize: '9px',
                      paddingBottom: '2px',
                      minHeight: '14px'
                    }}>
                      {categoryData[`item_${num}`] || ''}
                    </div>
                  </div>
                ))}
              </div>

              {/* Right Column - 2 items */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[4, 5].map(num => (
                  <div key={num} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '14px' }}>{categoryData[`item_${num}_checked`] ? '☑' : '☐'}</span>
                    <div style={{
                      flex: 1,
                      borderBottom: '1px solid #999',
                      fontSize: '9px',
                      paddingBottom: '2px',
                      minHeight: '14px'
                    }}>
                      {categoryData[`item_${num}`] || ''}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Total Count */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '9px', fontWeight: 'bold' }}>Total number of (✓):</span>
              <div style={{
                width: '35px',
                height: '35px',
                borderRadius: '50%',
                border: '3px solid #F4824C',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: 'bold',
                backgroundColor: 'white'
              }}>
                {totalChecked}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      margin: '0 auto',
      padding: '20mm',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      {/* Top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        fontSize: '13px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px',
        marginBottom: '15px'
      }}>
        Teacher Assessment
      </div>

      {/* Three Assessment Categories */}
      {renderAssessmentCategory('awareness', 'Awareness')}
      {renderAssessmentCategory('sensitivity', 'Sensitivity')}
      {renderAssessmentCategory('creativity', 'Creativity')}

      {/* Brief Comments Section */}
      <div style={{
        backgroundColor: '#FFE5D5',
        padding: '12px',
        marginTop: '15px'
      }}>
        <div style={{ fontWeight: 'bold', fontSize: '10px', marginBottom: '8px' }}>
          Brief comments and pedagogical interventions recommended:
        </div>
        <div style={{
          fontSize: '9px',
          lineHeight: '1.4',
          minHeight: '120px',
          whiteSpace: 'pre-wrap'
        }}>
          {teacherFields.brief_comments || ''}
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        32
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartDPage2;
